import { WorksheetStatus } from "src/models/multidimensional-allocation/MultiAllocationSheetData";

/** Sheet version lanes: -1 is the draft, 0 the live version, 1..N archived versions. */
export const DAS_DRAFT_VERSION = -1;
export const DAS_LIVE_VERSION = 0;

/**
 * Sheet-level metadata returned by the DAS Smithy ops. Shape matches
 * `DerivedAllocationSheetData` in the WebAPILambda model package.
 */
export interface DerivedAllocationSheetData {
    sheetId: string;
    sheetName: string;
    description: string;
    sheetVersion: number;
    currentVersion: number;
    status: WorksheetStatus;
    stepsCount: number;
    /** Null until Step 4 is saved. */
    segmentType?: string;
    /** Null until Step 4 is saved. */
    mappingSegmentCdtId?: string;
    /** Null until Step 4 is saved. */
    mappingColumnId?: string;
    /** Null until the sheet has executed in the live lane. */
    outputS3Url?: string;
    /** Null until the sheet has executed in the draft lane. */
    draftOutputS3Url?: string;
    allocationGroupIds: string[];
    contentModifiedDate: number;
    /** Null until the first successful execution. */
    lastExecutionTimestamp?: number;
    createdBy: string;
    createdAt: string;
    lastModifiedBy: string;
    lastModifiedDate: string;
    /** Null until the sheet is submitted for review. */
    submitUser?: string;
    submitDate?: string;
    /** Null until the sheet is approved or rejected. */
    reviewUser?: string;
    reviewDate?: string;
    comment?: string;
}

export interface ListDerivedAllocationSheetsResponse {
    sheets: DerivedAllocationSheetData[];
}
